module.exports = __webpack_public_path__ + "img/90.7971888b.jpg";